module.exports = __webpack_public_path__ + "img/icon_list_fabulous2.9e6f2df2.svg";